import React, { useState, useEffect } from "react";
import { navigate } from "@reach/router";
import GameList from "./GameList";
import GameDetails from "./GameDetails";
import { PageContainer } from "../../../globals/components/containers";
import gamesOriginal from "../game_data";
import useServices from "../hooks/useServices"
import useClassSettings from "../hooks/useClassSettings"
import { debug } from "util";



var searched = false;
var found = -1;

export default function Index(props)
{
  var games = gamesOriginal;
  const [selectedGame, setSelectedGame] = useState(null);
    const { services } = useServices();
    const { settings } = useClassSettings();
  function onGameSelect(id)
  {
    const game = games.find(function (g)
    {
      return g.id === id;
    });

    //setGameView(true);
    setSceneView(0);
    setSelectedGame(game);
  }

  function ShowGameView()
  {
    setSceneView(0);
  }

  function ShowProgress() {
    //setGameView(!gameview)
    setSceneView(1);
  }

  function ShowRewards(){
    setSceneView(2);
  }
  const [gameview, setGameView] = useState(true);
const[sceneview, setSceneView] = useState(0);

  //select first game on mount
  useEffect(() =>
  {
    onGameSelect(9);
  }, []);


  useEffect(() =>{
      if (services !== undefined)
      {
        console.log(settings);
        console.log(services);
        if (settings != undefined){
          var classServices = JSON.parse(settings.services_enabled);
          console.log(classServices);
        }
        for (var i = 0; i < games.length; i++)
        {
          games[i].playable = false;
            console.log("this is " + games[i].playable);
            for (var o = 0; o < services.length; o++)
            {
              if (games[i].id == services[o].id)
              {
                games[i].playable = true;
                //check if allowed to play on game settings
                if (classServices == null || classServices.length == 0){
                  games[i].playable = true;
                }else{
                  classServices.forEach(cservice => {
                    if (cservice.service_id == games[i].id){
                      if (cservice.enabled == 1){
                        games[i].playable = true;
                      }else{
                        games[i].playable = false;
                      }
                    }
                  });
                }
                
                if(found === -1)
                {
                  onGameSelect(games[i].id);
                  found = games[i].id;
                }
              }
            
            //console.log("now it is " + games[i].playable);
          }
        }
  
        //make sure asssessments always playable
        for (var i = 0; i < games.length; i++)
        {
          if (games[i].id == 35){
            games[i].playable = true;
          }
        }
        games.sort(function (a, b)
        {
          return b.playable - a.playable
        });
      }else{
          for (var i = 0; i < games.length; i++)
          {
            //games[i].playable = false;
            console.log("no services found");
          }
      }
  },[services, settings]);



 

  console.log(props);

  //check if important assignment
  if (props.hasImportant == true){
    navigate("/assignments");
  }

  return (
    <PageContainer>
      <GameList
        games={games}
        selectedGameId={selectedGame !== null ? selectedGame.id : null}
        onGameSelect={onGameSelect}
      />
      <GameDetails
        selectedGame={selectedGame !== null ? selectedGame : null}
        goToGame={() => navigate(`games/${selectedGame.id}`)}        
        ShowProgress = {ShowProgress}
        gameview = {gameview}
        ShowRewards = {ShowRewards}
        sceneview = {sceneview}
        ShowGameView = {ShowGameView}
      />
    </PageContainer>
  );
}



